import { useEffect } from "react";
import { useLocation, useOutlet } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { WhatsAppFloat } from "@/components/site/WhatsAppFloat";
import { GoogleVerify } from "@/components/site/GoogleVerify";
import { usePageTracking } from "@/lib/track";
import { useLang } from "@/lib/i18n";

export default function SiteLayout() {
  const { pathname } = useLocation();
  const { lang } = useLang();
  const outlet = useOutlet();
  usePageTracking(pathname, lang);
  useEffect(() => {
    if ("scrollRestoration" in window.history) window.history.scrollRestoration = "manual";
  }, []);
  return (
    <div className="site-scale flex min-h-screen flex-col bg-white">
      <Navbar />
      <main className="flex-1">
        <AnimatePresence mode="wait" initial={false} onExitComplete={() => window.scrollTo(0, 0)}>
          <motion.div key={pathname} initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -12 }} transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }} data-testid="page-transition">
            {outlet}
          </motion.div>
        </AnimatePresence>
      </main>
      <Footer />
      <WhatsAppFloat />
      <GoogleVerify />
    </div>
  );
}
